import { Separator } from "@/components/ui/separator"
import Link from "next/link"

export function Footer() {
  const currentYear = new Date().getFullYear()
  
  return (
    <footer className="w-full mt-auto">
      <Separator className="my-4" />
      <div className="container flex flex-col items-center justify-center py-4 space-y-2">
        <div className="flex items-center space-x-4">
          <Link href="/terms" className="text-sm text-muted-foreground hover:text-foreground">
            Terms of Use
          </Link>
          <span className="text-muted-foreground">•</span>
          <Link href="/privacy" className="text-sm text-muted-foreground hover:text-foreground">
            Privacy Policy
          </Link>
        </div>
        <p className="text-sm text-muted-foreground">
          © {currentYear} Ensemble. All rights reserved.
        </p>
      </div>
    </footer>
  )
}